import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface IProps {
  isLoading: boolean;
  children: React.ReactNode;
  height?: number;
  minHeight?: number;
  text?: string;
}

const LoadingWrapper = ({ text, height, isLoading, minHeight, children }: IProps): React.ReactElement => {
  const { t } = useTranslation();
  return isLoading ? (
    <LoadingContainer height={height} minHeight={minHeight}>
      {text || t`common.loading`}
    </LoadingContainer>
  ) : (
    <>{children}</>
  );
};

export { LoadingWrapper };

const LoadingContainer = styled.div.attrs({ className: 'd-flex justify-content-center align-items-center w-100' })<{
  height?: number;
  minHeight?: number;
}>`
  min-height: ${({ minHeight = 100 }) => `${minHeight}px`};
  height: ${({ height }) => (!!height ? `${height}px` : '100%')};
`;
